import script from "./PayOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./PayOrder.vue?vue&type=script&setup=true&lang=js"

import "./PayOrder.vue?vue&type=style&index=0&id=1f1d7630&scoped=true&lang=less"
import "./PayOrder.vue?vue&type=style&index=1&id=1f1d7630&lang=less"

import exportComponent from "/data/web/pay/brpay/brpay-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f1d7630"]])

export default __exports__